/* eslint-disable no-undef */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useScript from '@lmig/dotcom-aspect-hooks/useScript';

const YouTube = ({ videoId, videoIsVisible = true, experience = undefined }) => {
  const [loaded] = useScript(`https://www.youtube.com/player_api`);

  const containerRef = useRef();
  const player = useRef();
  const [youTube, setYouTube] = useState({});

  useEffect(() => {
    if (loaded && youTube.playVideo) {
      youTube.videoIsVisible = videoIsVisible;

      if (!youTube.videoIsVisible && player.current) {
        youTube.pauseVideo();
      }

      if (youTube.videoIsVisible && player.current && experience) {
        youTube.playVideo();
      }
    }
  }, [youTube, videoIsVisible, loaded, experience]);

  useEffect(() => {
    if (loaded && window.YT && window.YT.ready && Object.keys(youTube).length === 0) {
      window.YT.ready(() => {
        setYouTube(new YT.Player(containerRef.current, {
          height: '360',
          width: '640',
          videoId,
          playerVars: {
            modestbranding: 1,
            enablejsapi: 1,
            origin: 'liberty-mutual.com',
            rel: 0,
          },
        }))
        player.current = youTube;
      });
    }
  }, [youTube, videoId, loaded]);

  return (
    <div className="videoWrapper">
      <div className="dummyYouTubeContainer" ref={containerRef} />
      <style jsx>{`@import './YouTube.scoped.scss';`}</style>
    </div>
  );
};

YouTube.propTypes = {
  videoId: PropTypes.string.isRequired,
  videoIsVisible: PropTypes.bool,
  experience: PropTypes.bool,
};

export default YouTube;
